import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { campaignsService, Campaign } from '@aslanpay/portal-common-lib';

const useUnpublishCampaign = (options: UseMutationOptions<Campaign, Error, string>) => {
  return useMutation<Campaign, Error, string>(
    (campaignId) => campaignsService.unpublishCampaign(campaignId),
    options
  );
};

export default useUnpublishCampaign;
